import React, { Component } from 'react';
import PropTypes from 'prop-types';
import * as jwt_decode from 'jwt-decode';
import { withRouter } from 'react-router-dom';
import { Layout, Row, Col, Card, DatePicker, Badge, Spin } from 'antd';
//import ReactHighcharts from 'react-highcharts';
import Highcharts from 'highcharts';
import moment from 'moment';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { getUserData } from '../../redux/actions';

import Header from '../../components/Header';
import Sidebar from '../../components/Sidebar';
import Breadcrumb from '../../components/Breadcrumb';

import Service from './Service';
import './styles.css';

const { Content } = Layout;

// Dois formatos DIFERENTES de proposito:
// - FORMATO_API e o que o back-end espera na URL e o que guardamos no state.
//   Nao mudar: as rotas sao /{dataInicial}/{dataFinal}/ e o DateTime do C#
//   interpreta aaaa-mm-dd.
// - FORMATO_EXIBICAO e so o que o usuario ve no campo.
// Cuidado ao mexer no onChange: o antd entrega a data ja formatada conforme
// FORMATO_EXIBICAO, entao a string dele NAO serve pra chamar a API - por isso
// lemos dos objetos moment.
const FORMATO_API = 'YYYY-MM-DD';
const FORMATO_EXIBICAO = 'DD/MM/YYYY';

class Nps extends Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      data: {},
      dataChart: {},
      loading: false,
      idGrupo: 0,
      idUnidade: 0
    };

    this.service = new Service();
    this._isMounted = false;
  }

  componentDidMount() {
    this._isMounted = true;
    if (!this.service.isLogged()) {
      this.props.history.push('/login');
    } else {
      const token = this.props.userData.object.token;
      const decodeToken = jwt_decode(token);
      this.setState({
        role: decodeToken.role,
        dataUser: decodeToken,
      });

      this.handleDate();
    }
  }

  // Sem isso, uma busca ainda em andamento quando o usuario navega pra
  // outra tela (o componente desmonta, mas a promise continua rodando)
  // acabava chamando setState + highChartsRenderNps num estado que nunca
  // foi atualizado de verdade.
  componentWillUnmount() {
    this._isMounted = false;
  }

  // Unidade selecionada no Header. filialId e a UNICA fonte que representa
  // "Ver todas as unidades" (sentinela 999999): nesse caso dataFilial fica
  // vazia, entao ler dataFilial[0].id fazia a tela pedir os dados de UMA
  // filial - a selecionada antes, que continua no Redux durante a troca,
  // porque o Header despacha 4 acoes separadas - e exibir o total dela no
  // lugar do consolidado da empresa. O seletor de data ja usava filialId,
  // o que deixava as duas rotas da mesma tela discordando entre si.
  unidadeSelecionada = (props = this.props) =>
    props.filialId > 0
      ? props.filialId
      : props.dataFilial.length > 0
      ? props.dataFilial[0].id
      : 0;

  componentWillReceiveProps(props) {
    const idUnidade = this.unidadeSelecionada(props);
    const idGrupo = props.companySelected.length > 0 ? props.companySelected[0].id : 0;
    this.setState({
      idUnidade,
      idGrupo
    });
    if((idUnidade > 0 && idUnidade !== this.state.idUnidade) || (idGrupo > 0 && idGrupo !== this.state.idGrupo)) {
      this.handleDate(idGrupo, idUnidade);
    }
  }

  handleDate = async (idGrupo, idUnidade) => {
    // componentWillReceiveProps pode chamar handleDate varias vezes seguidas
    // (o Header despacha 4 acoes Redux separadas ao trocar de filial, cada
    // uma dispara um re-render). Sem isso, uma chamada antiga que demora mais
    // pode responder DEPOIS da mais nova e sobrescrever o resultado certo
    // com dado desatualizado (o "pisca e volta pro estado antigo").
    const requestId = (this.requestSeq = (this.requestSeq || 0) + 1);
    this.setState({ loading: true });

    const dateFormat = 'YYYY-MM-DD';

    // Preserva o periodo escolhido no filtro. Antes, esta funcao recalculava
    // "ultimos 30 dias" fixo toda vez que rodava - inclusive ao trocar de
    // unidade - entao os dados voltavam pro padrao enquanto o campo do filtro
    // continuava exibindo o periodo escolhido (RangePicker nao-controlado).
    let teste =
      this.state.dataInitial ||
      moment(new Date(new Date().setDate(new Date().getDate() - 30))).format(
        dateFormat
      );
    let teste2 = this.state.dataFinal || moment(new Date()).format(dateFormat);

    const idUnidadePadrao = this.unidadeSelecionada();
    const idGrupoPadrao =
      this.props.companySelected.length > 0
        ? this.props.companySelected[0].id
        : 0;

    let result = await this.service.getDataNps(
      teste,
      teste2,
      idUnidade > 0 ? idUnidade : idUnidadePadrao,
      idGrupo > 0 ? idGrupo : idGrupoPadrao
    );
    console.log('result', result);

    if (!this._isMounted || requestId !== this.requestSeq) return;

    this.setState({
      dataChart: result.object,
      dataInitial: teste,
      dataFinal: teste2,
      loading: false,
    });
    this.highChartsRenderNps();
  };

  onChange = async (value, dateString) => {
    const requestId = (this.requestSeq = (this.requestSeq || 0) + 1);
    // Guarda o periodo escolhido: e ele que handleDate reusa quando o usuario
    // troca de unidade depois, e e o que o campo do filtro exibe.
    // Le dos objetos moment (1o argumento), NAO de dateString: essa vem no
    // formato de exibicao (dd/mm/aaaa) e a API espera aaaa-mm-dd.
    // Limpar o filtro deixa a lista vazia - nesse caso volta pro padrao.
    const inicio =
      value && value[0]
        ? value[0].format(FORMATO_API)
        : moment(new Date(new Date().setDate(new Date().getDate() - 30))).format(
            FORMATO_API
          );
    const fim =
      value && value[1]
        ? value[1].format(FORMATO_API)
        : moment(new Date()).format(FORMATO_API);

    this.setState({ loading: true, dataInitial: inicio, dataFinal: fim });

    const idGrupo =
      this.props.companySelected.length > 0
        ? this.props.companySelected[0].id
        : 0;

    let result = await this.service.getDataNps(
      inicio,
      fim,
      this.props.filialId,
      idGrupo
    );
    console.log('result date', result);

    if (!this._isMounted || requestId !== this.requestSeq) return;

    this.setState({ dataChart: result.object, loading: false });
    this.highChartsRenderNps();
  };

  onOk = value => {
    console.log('onOk: ', value);
  };

  zonasNps = () => {
    const { nps } = this.state.dataChart;

    if (nps <= 0) {
      return 'Crítica';
    } else if (nps < 51) {
      return 'Aperfeiçoamento';
    } else if (nps < 76) {
      return 'Qualidade';
    } else {
      return 'Excelência';
    }
  };

  highChartsRenderNps() {
    Highcharts.chart({
      chart: {
        type: 'column',
        renderTo: 'nps',
      },
      title: {
        text: null,
      },
      subtitle: {
        text: null,
      },
      credits: {
        enabled: false,
      },
      tooltip: {
        pointFormat: '{series.name}: <b>{point.y:.1f}%</b>',
      },
      yAxis: {
        allowDecimals: false,
        title: 'Totais',
      },
      xAxis: {
        // labels: {
        //   enabled: false,
        // },
        categories: ['NPS'],
      },
      colors: ['#f5222d', '#faad14', '#52c41a'],
      series: [
        {
          name: 'Detratores',
          data: [this.state.dataChart.percentDetratores],
        },
        {
          name: 'Neutros',
          data: [this.state.dataChart.percentNeutros],
        },
        {
          name: 'Promotores',
          data: [this.state.dataChart.percentPromotores],
        },
      ],
    });
  }

  render() {
    const { RangePicker } = DatePicker;

    const homeClient = {
      home: 'Início',
      user: 'Índice Blue',
      company: 'NPS',
      companyClient: 'Empresa',
      contracts: 'Evoluções',
      plans: 'Avaliações',
      indicadores: 'Visão Geral',
      configuration: 'Opções',
      logout: 'Sair',
      iconClient: {
        home: 'home',
        user: 'area-chart',
        company: 'pie-chart',
        companyClient: 'bank',
        contracts: 'line-chart',
        plans: 'message',
        indicadores: 'dashboard',
        configuration: 'setting',
        logout: 'logout',
      },
    };

    const routesClient = {
      home: 'client',
      user: 'indexBlue',
      company: 'nps',
      companyClient: 'companyClient',
      contracts: 'evolution',
      plans: 'comments',
      indicadores: 'indicadores',
      configuration: 'settings',
    };

    return (
      <Layout>
        <Sidebar
          dataSidebar={homeClient}
          routes={routesClient}
          current="dashboard"
        />
        <Layout>
          <Header dataUser={this.state.dataUser} />

          <Content
            style={{
              margin: '24px 16px',
              padding: 24,
            }}
          >
            <Spin spinning={this.state.loading} size="large">
              <Row className="nopadding-col">
                <Col md={{ span: 16 }} xs={{ span: 24 }}>
                  <Breadcrumb pages={[{ title: 'NPS' }]} />
                </Col>
              </Row>
              <Row
                style={{
                  display: 'flex',
                  alignItems: 'flex-end',
                  justifyContent: 'flex-end',
                  marginBottom: 20,
                }}
              >
                {this.state.dataInitial !== undefined ? (
                  // Controlado (value, nao defaultValue): assim o campo sempre
                  // reflete o periodo que os dados na tela realmente usam.
                  <RangePicker
                    value={[
                      moment(this.state.dataInitial, FORMATO_API),
                      moment(this.state.dataFinal, FORMATO_API),
                    ]}
                    format={FORMATO_EXIBICAO}
                    onChange={this.onChange}
                    onOk={this.onOk}
                  />
                ) : null}
              </Row>
              <Row gutter={16}>
                <Col
                  xs={{ span: 24 }}
                  sm={{ span: 12 }}
                  md={{ span: 12 }}
                  lg={{ span: 6 }}
                >
                  <Card title="Avaliações" className="tcenter">
                    <h1
                      style={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        fontSize: 40,
                        fontWeight: 'bold',
                      }}
                    >
                      {this.state.dataChart.totalAvaliacao}
                    </h1>
                    <Row
                      style={{
                        display: 'flex',
                        justifyContent: 'flex-end',
                        alignItems: 'flex-end',
                      }}
                    >
                      <p style={{ marginBottom: -10 }}>100%</p>
                    </Row>
                  </Card>
                </Col>
                <Col
                  xs={{ span: 24 }}
                  sm={{ span: 12 }}
                  md={{ span: 12 }}
                  lg={{ span: 6 }}
                >
                  <Card
                    title={
                      <span style={{ color: '#f5222d', fontWeight: 'bold' }}>
                        Detratores
                      </span>
                    }
                    className="tcenter"
                  >
                    <h1
                      style={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        fontSize: 40,
                        fontWeight: 'bold',
                      }}
                    >
                      {this.state.dataChart.totalDetratores}
                    </h1>
                    <Row
                      style={{
                        display: 'flex',
                        justifyContent: 'flex-end',
                        alignItems: 'flex-end',
                      }}
                    >
                      <p style={{ marginBottom: -10 }}>
                        {this.state.dataChart.percentDetratores &&
                          this.state.dataChart.percentDetratores.toFixed()}
                        %
                      </p>
                    </Row>
                  </Card>
                </Col>
                <Col
                  xs={{ span: 24 }}
                  sm={{ span: 12 }}
                  md={{ span: 12 }}
                  lg={{ span: 6 }}
                >
                  <Card
                    title={
                      <span style={{ color: '#faad14', fontWeight: 'bold' }}>
                        Neutros
                      </span>
                    }
                    className="tcenter"
                  >
                    <h1
                      style={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        fontSize: 40,
                        fontWeight: 'bold',
                      }}
                    >
                      {this.state.dataChart.totalNeutros}
                    </h1>
                    <Row
                      style={{
                        display: 'flex',
                        justifyContent: 'flex-end',
                        alignItems: 'flex-end',
                      }}
                    >
                      <p style={{ marginBottom: -10 }}>
                        {this.state.dataChart.percentNeutros &&
                          this.state.dataChart.percentNeutros.toFixed()}
                        %
                      </p>
                    </Row>
                  </Card>
                </Col>
                <Col
                  xs={{ span: 24 }}
                  sm={{ span: 12 }}
                  md={{ span: 12 }}
                  lg={{ span: 6 }}
                >
                  <Card
                    title={
                      <span style={{ color: '#52c41a', fontWeight: 'bold' }}>
                        Promotores
                      </span>
                    }
                    className="tcenter"
                  >
                    <h1
                      style={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        fontSize: 40,
                        fontWeight: 'bold',
                      }}
                    >
                      {this.state.dataChart.totalPromotores}
                    </h1>
                    <Row
                      style={{
                        display: 'flex',
                        justifyContent: 'flex-end',
                        alignItems: 'flex-end',
                      }}
                    >
                      <p style={{ marginBottom: -10 }}>
                        {this.state.dataChart.percentPromotores &&
                          this.state.dataChart.percentPromotores.toFixed()}
                        %
                      </p>
                    </Row>
                  </Card>
                </Col>
              </Row>
              <Row style={{ flexDirection: 'row' }} gutter={16}>
                <Col
                  xs={{ span: 24 }}
                  sm={{ span: 24 }}
                  md={{ span: 18 }}
                  lg={{ span: 18 }}
                  style={{ marginBottom: 30, marginTop: 30 }}
                >
                  <Row>
                    <Col
                      xs={{ span: 24 }}
                      sm={{ span: 24 }}
                      md={{ span: 24 }}
                      lg={{ span: 24 }}
                      style={{ marginBottom: 10 }}
                      className="home-charts"
                    >
                      {/* <ReactHighcharts config={config1} /> */}
                      <div id="nps"></div>
                    </Col>
                  </Row>
                </Col>
                <Col
                  xs={{ span: 24 }}
                  sm={{ span: 24 }}
                  md={{ span: 6 }}
                  lg={{ span: 6 }}
                  style={{ marginTop: 26 }}
                >
                  <Row style={{ flexDirection: 'column' }} gutter={16}>
                    <Col
                      xs={{ span: 24 }}
                      sm={{ span: 12 }}
                      md={{ span: 24 }}
                      lg={{ span: 24 }}
                    >
                      <Card title="NPS" className="tcenter">
                        <h1
                          style={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            fontSize: 40,
                            fontWeight: 'bold',
                          }}
                        >
                          {this.state.dataChart.nps &&
                            this.state.dataChart.nps.toFixed()}
                        </h1>
                        <p
                          style={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            fontSize: 14,
                            fontWeight: 'bold',
                          }}
                        >
                          {this.zonasNps()}
                        </p>
                      </Card>
                    </Col>
                    <Col
                      xs={{ span: 24 }}
                      sm={{ span: 12 }}
                      md={{ span: 24 }}
                      lg={{ span: 24 }}
                    >
                      <Card title="Zonas do NPS" className="tcenter">
                        <Row style={{ flexDirection: 'column' }}>
                          <Col span={24} style={{ marginTop: -16 }}>
                            <Badge color="red" text="Crítica -100 a 0" />
                          </Col>
                          <Col span={24}>
                            <Badge
                              color="yellow"
                              text="Aperfeiçoamento 1 a 50"
                            />
                          </Col>
                          <Col span={24}>
                            <Badge color="green" text="Qualidade 51 a 75" />
                          </Col>
                          <Col span={24}>
                            <Badge color="blue" text="Excelência 76 a 100" />
                          </Col>
                        </Row>
                      </Card>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Spin>
          </Content>
        </Layout>
      </Layout>
    );
  }
}

Nps.propTypes = {
  history: PropTypes.object.isRequired,
};

const mapDispatchToProps = dispatch =>
  bindActionCreators({ getUserData }, dispatch);

const mapStateToProps = store => ({
  userData: store.userData.data,
  clientFilial: store.userData.clientFilial,
  filialId: store.userData.filialId,
  companySelected: store.userData.companySelected,
  dataFilial: store.userData.dataFilial
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(Nps));
